import axios from "axios";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const customerApi = axios.create({ baseURL: BASE });
customerApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("wb_customer_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
customerApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/customer")) {
      localStorage.removeItem("wb_customer_token");
      localStorage.removeItem("wb_customer_user");
      window.location.href = "/auth";
    }
    return Promise.reject(err);
  }
);

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" · ");
  return String(d);
};
